/**************************************************
 * Nombre:       Footer
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import fondo from '../Recursos/fondo_footer.svg'
import logo from '../Recursos/logo_blanco.svg'
import Boton from "./Secciones/Componentes/Subcomponentes/Boton";
import {CONTACTOS, NEGRITA, SECCIONES} from "../Constantes";
import {useResponsive} from "../Modulo_responsive/Hooks/useResponsive";
import {useDialogo} from "../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Registro from "./Dialogos/Dialogo_Registro";
import {irUrl} from "../Utilidades/irUrl";
import {useIrRuta} from "../Utilidades/useIrRuta";

const Footer = ({item}) => {
    const {sCell} = useResponsive()
    const {ir} = useIrRuta()
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Registro, titulo: 'Formulario de Registro'})

    const abrirRegistro = () => {

        abrir(item);
    }

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                background: `url(${fondo})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
            }}
        >

            <Dialogo/>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: '#fff', py: 8}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={4}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={0}
                            >

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <img src={logo} width={280} height={'auto'}/>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 9}}
                                      sx={{justifyContent: 'flex-start', mt: 3}}>
                                    <Typography sx={{fontSize: 14}}>
                                        "Formación de Operadores de Justicia con Perspectiva de Género y Enfoque
                                        Diferencial"
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 4}}>
                                    <Boton
                                        click={abrirRegistro}
                                        texto={'Obtener mi certificado'}/>
                                </Grid>

                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 4, md: 3}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={0}
                            >

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{fontFamily: NEGRITA, fontSize: 24}}>Links Rapidos</Typography>
                                </Grid>

                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}
                                    sx={{mt: 2}}
                                >

                                    {SECCIONES.map((item, i) => (
                                        <Grid
                                            onClick={() => ir(item)}
                                            container size={{xs: 12, sm: 12, md: 12}}
                                            sx={{justifyContent: 'flex-start', mt: 1, cursor: 'pointer'}}>
                                            <Typography
                                            sx={{
                                                borderBottom: 1,
                                                borderColor: "#00000000",
                                                fontWeight: 400,
                                                transition: 'all .2s ease-in-out',
                                                "&:hover": {
                                                    borderColor: "#fff",
                                                }
                                            }}
                                            >{item}</Typography>
                                        </Grid>
                                    ))}


                                </Grid>

                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 8, md: 5}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={0}
                            >

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{fontFamily: NEGRITA, fontSize: 24}}>Contactos</Typography>
                                </Grid>

                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}
                                    sx={{mt: 2}}
                                >

                                    {CONTACTOS.map((item, i) => (
                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start', mt: 2}}>
                                            <Typography
                                                onClick={() => irUrl(item.url)}
                                                sx={{cursor: 'pointer'}}>
                                                {!sCell && <span>
                                            <img src={item.img} width={18} height={'auto'}
                                                 style={{marginRight: 10, marginTop: 2, marginBottom: -2}}/>
                                        </span>}
                                                {item.descripcion}
                                            </Typography>
                                        </Grid>
                                    ))}


                                </Grid>

                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    backgroundColor: '#222353',
                    px: 3,
                    py: 1,
                    mt: -4
                }}
            >

                <Typography sx={{textAlign: 'center', color: '#ffffff80', fontSize: sCell ? 12 : 14}}>
                    © Copyright 2026 - 2027 | Centro de conciliacion, arbitraje, amigable composicion e insolvencia
                </Typography>


            </Grid>

        </Grid>
    )

}
export default Footer